import { Injectable } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { filter, withLatestFrom } from 'rxjs/operators'
import { MbCheckoutQuoteInfoFacade } from '../../checkout/facades/mb-checkout-quote-info.facade'
import { MbConstants } from '../mb-constants'
import { MbCheckoutTypes, MbQuoteInfoModel } from '../../models'
import { ActiveCartService } from '@spartacus/cart/base/core'
import { Cart } from '@spartacus/cart/base/root'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutService {

  private mbCheckoutTypes = MbCheckoutTypes
  private constants = MbConstants
  private doNotResendFlag: boolean = false

  constructor (protected router: Router,
               protected mbCheckoutQuoteInfoService: MbCheckoutQuoteInfoFacade,
               protected activeCartService: ActiveCartService) {
  }

  init () {
    //TODO this is bs and should be refactored
    this.router.events.pipe(
      withLatestFrom(this.activeCartService.getActive()),
      filter(([event, cart]: [any, Cart]) => event instanceof NavigationEnd
        && cart?.checkoutStatus?.checkoutType !== this.mbCheckoutTypes.CHECKOUT_TYPE_D
        && cart?.checkoutStatus?.checkoutType !== this.mbCheckoutTypes.CHECKOUT_TYPE_E)
    ).subscribe(([event, cart]: [NavigationEnd, Cart]) => {
      if (!event?.url.includes('/' + this.constants.CHECKOUT + '/') && !this.doNotResendFlag) {
        this.mbCheckoutQuoteInfoService.postQuoteInfoDetails({ flag: false } as MbQuoteInfoModel)
        this.doNotResendFlag = true
      } else {
        this.doNotResendFlag = false
      }
    })
  }
}
